
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class ItemModel extends Model<ItemModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'no', type: 'string', languageString: 'item.property.no' },
		{ name: 'description', type: 'string', languageString: 'item.property.description' }
	];
	[key: string]: any;
	
	public no: string;
	public description: string;
    
	constructor(){
		super();
		this.no = '';
		this.description = '';
		
	}
	getProperties(){
		return ItemModel.classProperties;
	}
}

